import ApiService from './api-service'
import { getUserFromLocalStorage } from '../utils/utils-functions'
import { User } from './login/interface'

interface ILogData {
  data: unknown;
  user: User | null;
  browser: string;
}

export const postLogData = (data: unknown) => ApiService.post<ILogData, Promise<never>>('/log', {
  data: {
    data,
    user: getUserFromLocalStorage(),
    browser: navigator.userAgent
  }
})
